import { useState, useRef, forwardRef, useEffect } from "react";
import useClickOutside from "/src/hooks/useClickOutside";
import "./DropDown.css";

const DropDown = forwardRef(
    (
        {
            choices,
            placeholder,
            defaultChoice,
            heightFix,
            className,
            width,
            name,
            onChange,
            onBlur,
            setValue,
            icon,
            hideSelectItem,
            noChangeOnSelect,
            reverse,
            disabled,
        },
        ref
    ) => {
        // Définition du choix par défaut
        if (defaultChoice) {
            defaultChoice = choices.find((choice) => choice.value === defaultChoice) || choices[0];
        }

        if (placeholder) {
            defaultChoice = { text: placeholder, value: "" };
        }

        const [expanded, setExpanded] = useState(false);
        const [selected, setSelected] = useState(defaultChoice);
        const [lastDefaultChoice, setLastDefaultChoice] = useState(defaultChoice);

        if (lastDefaultChoice.value !== defaultChoice.value) {
            setSelected(defaultChoice);
            setLastDefaultChoice(defaultChoice);
        }

        if (hideSelectItem === true) {
            choices = choices.filter((choice) => selected.value !== choice.value);
        }

        const listStyle = {
            overflowY: expanded ? "auto" : "hidden",
            height: expanded ? heightFix || `${choices.length * 35}px` : "0",
            paddingTop: reverse ? "0px" : "",
            bottom: reverse ? "15px" : "",
        };

        // Définit la largeur maximale
        const maxWidth = typeof width === "number" ? `${width - 60}px` : `calc(${width} - 60px)`;
        const adjustedWidth = typeof width === "number" ? `${width}px` : width;

        const onClick = () => {
            if (!expanded && dropdownRef.current) {
                dropdownRef.current.style.zIndex = 10;
            } else {
                setTimeout(() => (dropdownRef.current ? (dropdownRef.current.style.zIndex = 0) : null), 500);
            }
            setExpanded(!expanded);
        };

        const onSelect = (choice) => {
            if (choice.text === "Import my logo") {
                const fileInput = document.createElement("input");
                fileInput.type = "file";
                fileInput.name = "avatar";
                fileInput.click();
                fileInput.addEventListener("change", (event) => {
                    const file = event.target.files[0];
                    if (setValue) {
                        setValue(name, file, { state: selected, func: setSelected });
                        setSelected({ value: file.name, text: file.name });
                    }
                });
            } else {
                if (!noChangeOnSelect) setSelected(choice);
                setExpanded(false);
                setTimeout(() => (dropdownRef.current ? (dropdownRef.current.style.zIndex = 0) : null), 500);
                if (setValue) {
                    setValue(name, choice.value, { state: selected, func: setSelected });
                }
                if (onChange) {
                    onChange(choice); // Notifie le parent lors de la sélection
                }
            }
        };

        const dropdownRef = useRef("dropdown");
        useClickOutside(dropdownRef, () => {
            if (expanded) setTimeout(() => (dropdownRef.current ? (dropdownRef.current.style.zIndex = 0) : null), 500);
            setExpanded(false);
        });

        // Définition de la fonction createChoice
        const createChoice = (choice) => {
            const iconPadding = icon ? 30 : 60;
            const paddingLeft = choice.icon ? 0 : 25;

            return (
                <>
                    {choice.icon &&
                        (typeof choice.icon === "string" ? (
                            <div className="icon" style={{ backgroundImage: `url(${choice.icon})` }}></div>
                        ) : (
                            <div className="icon">{choice.icon}</div>
                        ))}
                    <span
                        className="text"
                        style={{
                            fontWeight: selected.value === choice.value ? 700 : 400,
                            maxWidth: `calc(${width} - ${iconPadding}px)`,
                            paddingLeft,
                        }}>
                        {choice.text}
                    </span>
                </>
            );
        };

        if (disabled) {
            className = className ? `${className} disabled` : "disabled";
        }
        className = className ? `dropdown ${className}` : "dropdown";

        const iconBackground = icon || selected.icon;
        const paddingLeft = iconBackground ? 0 : 25;

        return (
            <div className={className} ref={dropdownRef} style={{ position: "relative" }}>
                <input
                    ref={ref}
                    onChange={onChange}
                    onBlur={onBlur}
                    name={name}
                    type="hidden"
                    value={selected.value == null ? "" : selected.value}></input>
                <div className="custom-dropdown" style={{ width: adjustedWidth }} onClick={onClick}>
                    {iconBackground &&
                        (typeof iconBackground === "string" ? (
                            <div
                                className="icon"
                                style={{
                                    width: "25px",
                                    height: "25px",
                                    backgroundImage: `url(${iconBackground})`,
                                }}></div>
                        ) : (
                            <div className="icon" style={{ width: "auto", backgroundColor: "white" }}>
                                {iconBackground}
                            </div>
                        ))}
                    <span className="text" style={{ maxWidth, paddingLeft }}>
                        {selected.text}
                    </span>
                    <div className="container-arrow">
                        <div className={`arrow ${expanded ? "reverse" : ""}`} />
                    </div>
                    <ul style={{ ...listStyle }}>
                        {choices.map((choice, index) => (
                            <li key={index} onClick={() => onSelect(choice)}>
                                {createChoice(choice)}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
);

DropDown.defaultProps = {
    width: 170,
    choices: [],
    disable: false,
    name: "",
    defaultChoice: "",
    icon: "",
    hideSelectItem: true,
    noChangeOnSelect: false,
    reverse: false,
};

export default DropDown;
